export function estimatedArrival(o, now = new Date()) {
    if (o.type !== "delivery" || ["new", "delivered", "completed", "cancelled"].includes(o.status))
        return null;
    const km = Number(o.distance_km ?? 0);
    const ride = Math.min(60, Math.max(8, Math.round(km * 3) + 5)) * 60_000;
    const t = (d) => (d ? new Date(d).getTime() : null);
    // out of the stall already: from pickup; otherwise from when the stall expects to be done (never in the past)
    const outAt = o.status === "out_for_delivery" || o.status === "in_transit" ? t(o.dispatched_at) : null;
    const base = outAt ?? Math.max(t(o.ready_at) ?? 0, t(o.est_ready_at) ?? 0, now.getTime());
    return new Date(base + ride);
}
//# sourceMappingURL=eta.js.map